import en from '@messages/en.json';
import es from '@messages/es.json';
import pt from '@messages/pt.json';

export const LOCAL_TRANSLATIONS = {
  en: en,
  es: es,
  pt: pt,
};
